<p-messages *ngIf="tipo==='porEnviar' && listExams.length>0" severity="info">
  <ng-template pTemplate>
    <div class="p-ml-2">
      <i class="pi pi-info-circle" style="margin-right: 10px"></i>
      <strong>Los exámenes en esta bandeja serán enviados automáticamente apenas se detecte
        conexión a internet.
      </strong>
    </div>
  </ng-template>
</p-messages>

<p-dataView #dv [filterBy]="filterBy" [pageLinks]="0" [paginatorPosition]="'top'" [paginator]="true"
  [rowsPerPageOptions]="[5,10,20,30]" [rows]="confPage.rows" [showCurrentPageReport]="true" [showFirstLastIcon]="false"
  [value]="listExams" [first]="confPage.first" (onPage)="onPage($event, tipo)"
  currentPageReportTemplate="{first} - {last} de {totalRecords} exámenes" emptyMessage=" ">

  <ng-template pTemplate="paginatorleft">

    <div style="display: flex">
      <div class="field-paginator-left">
        <div class="p-input-icon-right">
          <i class="pi pi-search"></i>
          <input (input)="actionFilter($event)" [(ngModel)]="inputSearch" id="search" name="seacrh" pInputText
            placeholder="Buscar" type="search">
        </div>
      </div>
      <div *ngIf="showSelectDeResultados()" style="margin-right: 10px; display: flex;">
        <div style="margin-top: 8px;">
          Resultados:
        </div>
        <p-dropdown [options]="resultadosElements" optionLabel="label" [ngModel]="resultadosValue"
          (onChange)="onChangeResultados($event)">
        </p-dropdown>
      </div>
      <div class="content_filter" style="display: flex; justify-content: flex-end; margin-top: 10px">

        <div style="display: flex;"
          *ngIf="tipo==='periodicos'|| tipo==='reevaluacion' || tipo==='porEnviar'" (click)="filtros()">

          <div class="filter-icon">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4 8C1.8 8 0 6.2 0 4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 14c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
              <path
                d="M23 5H7c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1zm0 8h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm-10 0H1c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1zm-3 11c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
              <path
                d="M23 21H13c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1zM7 21H1c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z" />
            </svg>
          </div>

          <label *ngIf="tipo==='periodicos'" class="filter-label">Filtros {{filterCountPeriodicos ? '(' +
            filterCountPeriodicos + ')' : ''}}</label>
          <label *ngIf="tipo==='reevaluacion'" class="filter-label">Filtros {{filterCountReevaluacion ? '(' +
            filterCountReevaluacion + ')' : ''}}</label>
          <label *ngIf="tipo==='porEnviar'" class="filter-label">Filtros {{filterCountPorEnviar ? '(' +
            filterCountPorEnviar + ')' : ''}}</label>
        </div>
        <label (click)="limpiarFiltro()" *ngIf=" tipo==='periodicos' &&filterCountPeriodicos"
          class="filter-label filter-clean">
          Limpiar Filtros</label>
        <label (click)="limpiarFiltro()" *ngIf=" tipo==='reevaluacion' &&filterCountReevaluacion"
          class="filter-label filter-clean">
          Limpiar Filtros</label>
        <label (click)="limpiarFiltro()" *ngIf=" tipo==='porEnviar' &&filterCountPorEnviar"
          class="filter-label filter-clean">
          Limpiar Filtros</label>
      </div>
    </div>

  </ng-template>

  <ng-template let-examen let-i="index" pTemplate="listItem">
    <div style="flex-direction: column; width: 100%; margin-bottom: 10px;">
      <app-examens-card-item (dismissCardCloseExam)="closeExam($event)" (refreshList)="refreshList()" [card]="examen" [isLastCardItem]="true"
        [prestador]="prestador" [actualizacionAsistencia]="cambioAsistencia">
      </app-examens-card-item>
    </div>
  </ng-template>
</p-dataView>

<div *ngIf="tipo==='periodicos'">
  <app-empty-state *ngIf="filterCountPeriodicos>0 && listExams.length<=0" [filterEmpty]="true"
    [subTittle]="'No se encontraron resultados para la búsqueda'" [tittle]="'No hay exámenes'">
  </app-empty-state>
  <app-empty-state *ngIf="listExams.length<=0 && filterCountPeriodicos<=0"
    [subTittle]="'No cuenta con exámenes para cargar'" [tittle]="'No hay exámenes'">
  </app-empty-state>
</div>

<div *ngIf="tipo==='reevaluacion'">
  <app-empty-state *ngIf="filterCountReevaluacion>0 && listExams.length<=0" [filterEmpty]="true"
    [subTittle]="'No se encontraron resultados para la búsqueda'" [tittle]="'No hay exámenes'">
  </app-empty-state>
  <app-empty-state *ngIf="listExams.length<=0 && filterCountReevaluacion<=0"
    [subTittle]="'No cuenta con exámenes para cargar'" [tittle]="'No hay exámenes'">
  </app-empty-state>
</div>

<div *ngIf="tipo==='porEnviar'">
  <app-empty-state *ngIf="sinRegistroFilter ||(filterCountPorEnviar>0 && listExams.length<=0) " [filterEmpty]="true"
    [subTittle]="'No se encontraron resultados para la búsqueda'" [tittle]="'No hay exámenes'">
  </app-empty-state>
  <!--    <app-empty-state *ngIf="listExams.length<=0 && filterCountPorEnviar<=0"-->
  <!--                     [subTittle]="'Todos los exámenes fueron enviados correctamente'"-->
  <!--                     [tittle]="'No hay exámenes'"></app-empty-state>-->
</div>